import { DocumentShared } from '@components';
import { RequestDto } from '@services';
import { Col, Collapse, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const { Text } = Typography;

interface IProps {
  request: RequestDto;
}

export const RequestNoteCollapse: React.FC<IProps> = ({ request }) => {
  const groupedConcerns =
    request.concerns?.reduce(
      (acc, concern) => {
        const category = concern.categoryName;
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(concern);
        return acc;
      },
      {} as Record<string, RequestDto['concerns']>
    ) || {};

  return (
    <Row style={{ marginTop: '20px' }}>
      <Col span={24}>
        <Collapse
          defaultActiveKey={['1']}
          items={[
            {
              key: '1',
              label: `Notes and documents`,
              children: (
                <>
                  <Row>
                    <Text>
                      Created: {dayjs(request.creationTime).local().format('DD/MM/YYYY HH:mm')}
                    </Text>
                  </Row>
                  <Row>
                    <Col>
                      <br />
                      {Object.entries(groupedConcerns).map(([category, concerns]) => (
                        <div key={category} style={{ marginBottom: '16px' }}>
                          <Text strong>{category}</Text>
                          <ul>
                            {concerns.map((concern) => (
                              <li key={concern.id}>
                                <Text>{concern.name}</Text>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </Col>
                  </Row>
                  {request?.note && (
                    <Row>
                      <Col>
                        <Text>{request.note}</Text>
                      </Col>
                    </Row>
                  )}
                  {request?.documents?.length ? (
                    <>
                      <br />
                      <Row>
                        <Col span={24}>
                          {request?.documents.map((document) => (
                            <DocumentShared hideDelete key={document.id} document={document} />
                          ))}
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  );
};
